<template>
    <div class="page-dashboard"> 
        <Topnavbar />
        <v-container class="mb80">
            <!-- <Carousel :items="sliders"/> -->
            <div class="pb-9">
                <v-row>
                    <v-col cols="6" sm="4" md="3" v-for="(item,index) in dashboardItems" :key="index" @click="handleRoute(item.route)">
                        <v-card class="dashboard-items" :class="[index == currentItem ? 'active-item':'']">
                            <div class="icon-wrapper">
                                <v-icon color="secondary">{{ item.icon }}</v-icon>
                            </div>
                             <p class="text-item">{{ item.name }}</p>
                        </v-card>
                    </v-col>
                </v-row>
                <div class="wrapper">
                    <div class="item-container" v-for="(service, index) in dashboardCustomer1" :key="index" @click="handleRoute(service.route)">
                        <div class="icon-wrapper">
                            <v-icon>mdi-account</v-icon>
                        </div>
                        <div class="text-wrapper w-100">
                            <p class="pa-0 ma-0 text-heading">{{ service.name }}</p>
                            <p class="pa-0 ma-0 text-sub-heading">Tagline here</p>
                        </div>
                    </div>
                </div>
                <v-row>
                    <v-col cols="12">
                       <h3>Upcoming Schedules</h3> 
                    </v-col>
                    <v-col cols="12" v-for="(n, index) in 5" :key="index">
                        <v-card class="border-radius-10 custom-bs" @click="handleRouter(n)">
                            <div class="pa-2 d-flex align-center">
                                <v-img
                                    lazy-src="https://picsum.photos/id/11/10/6"
                                    src="https://cdn.vuetifyjs.com/images/john.jpg"
                                    alt="John"
                                    class="border-radius-10"
                                    min-height="80"
                                    max-height="80"
                                    max-width="80"
                                ></v-img>
                                <div class="ml-4">
                                    <div class>
                                        <h4>Schedule 1</h4>
                                       <p class="f9-bold ma-0"><v-icon>mdi-date</v-icon>{{ formatDateTime()}}</p>
                                    </div>
                                    <p class="f8 mb-0"><v-icon>mdi-map-marker</v-icon> 80 kane st, west hardford</p>
                                </div>
                            </div>
                        </v-card>
                    </v-col>
                </v-row>
             
          </div>
        </v-container>
       
    </div>
</template>
<script>
import { mapGetters } from 'vuex'
import Topnavbar from '@/components/layout/Topnavbar'
import { ApiService } from '@/core/services/api.service'
import JwtService from '@/core/services/jwt.service'

export default {
    data() {
        return {
            currentItem:0,
            countMessages:0,
            dashboardItems: [],
            dashboardCustomer : [
                {name:'Calendar',icon:'mdi-calendar',component:'pest-control',route:'customer-calendar'},
                {name:'My Services',icon:'mdi-account',component:'pest-control',route:'customer-services'},
                // {name:'Pest Control',icon:'mdi-spider',component:'pest-control',route:'pest-control'},
                // {name:'Inspections',icon:'mdi-clipboard-text-multiple',component:'inspection',route:'inspection'},
                // {name:'Services',icon:'mdi-notebook-check',component:'services',route:'services'},
                // {name:'Card on File',icon:'mdi-clipboard-text-multiple',component:'card-on-file',route:'card-on-file'},
            ],
            dashboardCustomer1 : [
                // {name:'Calendar',icon:'mdi-calendar',component:'pest-control',route:'pest-control'},
                // {name:'My Services',icon:'mdi-account',component:'pest-control',route:'pest-control'},
                {name:'Pest Control',icon:'mdi-spider',component:'pest-control',route:'pest-control'},
                {name:'Inspections',icon:'mdi-clipboard-text-multiple',component:'inspection',route:'inspection'},
                // {name:'Services',icon:'mdi-notebook-check',component:'services',route:'services'},
                // {name:'Card on File',icon:'mdi-clipboard-text-multiple',component:'card-on-file',route:'card-on-file'},
            ],
            bottomItems:[
                {id:2, name:'Dashboard',route:'dashboard-customer',icon:'mdi-view-dashboard'},
                {id:3, name:'Pest Control',route:'pest-control', icon:'mdi-calendar'},
                {id:4, name:'Inspection',route:'inspection', icon:'mdi-account'},
            ],
            sliders: [
                {
                    src: 'https://cdn.vuetifyjs.com/images/carousel/squirrel.jpg',
                    route:'pest-identify'
                },
                {
                    src: 'https://cdn.vuetifyjs.com/images/carousel/sky.jpg',
                    route:'pest-home-remedy'
                },
                {
                    src: 'https://cdn.vuetifyjs.com/images/carousel/bird.jpg',
                    route:'pest-schedule-service'
                }
            ],
            dashboardAdministrative: [
                {name:"Profile",icon:'mdi-account',component:'profile-technician',route:'admin-profile'},
                {name:'Calendar',icon:'mdi-calendar-clock',route:'admin-calendar'},
                {name:'Services',icon:'mdi-calendar-clock',route:'admin-service'},
                {name:'Templates',icon:'mdi-calendar-clock',route:'admin-template'},
                {name:'Search Engine Articles',icon:'mdi-calendar-clock',route:'admin-article'},
                {name:'Customer Profiles',icon:'mdi-calendar-clock',route:'admin-customer-profile'},
                {name:'Technician Profiles',icon:'mdi-calendar-clock',route:'admin-technician-profile'},
                {name:'Record Payments',icon:'mdi-calendar-clock',route:'admin-payment-record'},
                {name:'Requests',icon:'mdi-calendar-clock',route:'admin-request'},
                {name:'Completed Scheduling',icon:'mdi-calendar-clock',route:'admin-completed-scheduling'}
            ],
            dashboardTechnical: [
                {name:"Profile",icon:'mdi-account',component:'profile-technician',route:'technical-profile'},
                {name:"Services",icon:'mdi-water-check',component:'home-remedy',route:'technical-service'},
                {name:"Assigned",icon:'mdi-water-check',component:'home-remedy',route:'technical-assigned-service'},
                {name:'Templates',icon:'mdi-calendar-clock',component:'schedule-service',route:'technical-template'},
                {name:'Calendar',icon:'mdi-calendar-clock',component:'schedule-service',route:'technical-calendar'}
            ],
        }
    },
    components: {
        Topnavbar,
        // Carousel,
        // Bottomnavbar
    },
    mounted() {
        // this.messageCount();
        this.setDashboardItem(JwtService.getToken());
        // console.log(JwtService.getToken());
    },
    methods: {
        setDashboardItem(token){
            switch(token) {
                case 'customer':
                    this.dashboardItems = this.dashboardCustomer;
                    break;
                case 'admin':
                    this.dashboardItems = this.dashboardAdministrative;
                    break;
                case 'technical':
                    this.dashboardItems = this.dashboardTechnical;
                    break;
                default:
                    // this.messageError('Sth wrong');
                    break;
            }
            // console.log(JwtSe)
        },
        handleRoute(route){
            this.$router.push("/"+route);
        },
        handleRouter(route){
            this.$router.push("/customer-service/"+route);
        },
        messageCount() {
            this.$bus.$emit('SHOW_PAGE_LOADER');
            ApiService.get('/messages/count/'+this.currentUser.vendor.id)
            .then((response) => {
                this.$bus.$emit('HIDE_PAGE_LOADER');
                this.countMessages = response.total;
            })
            .catch(() => {
                this.$bus.$emit('HIDE_PAGE_LOADER');
            });
        }
    },
    computed: {
        ...mapGetters(['currentUser'])
    }

}
</script>
<style lang="scss" scoped>
    $color-primary: #01a6bc;
    $color-secondary: #01a6bc;
    .active-item{
            // background:#cce3ff !important;
    }
    // .custom-bs{
    //     -webkit-box-shadow: 0px 0px 34px 1px rgba(222,222,222,1) !important;
    //     -moz-box-shadow: 0px 0px 34px 1px rgba(222,222,222,1) !important;
    //     box-shadow: 0px 0px 34px 1px rgba(222,222,222,1) !important;
    // }
    .dashboard-items{
        border-radius: 10px;
        text-align: center;
        display: flex;
        align-items: center;
        flex-direction: column;
        padding: 12px;
        -webkit-box-shadow: 0px 0px 34px 1px rgba(222,222,222,1) !important;
        -moz-box-shadow: 0px 0px 34px 1px rgba(222,222,222,1) !important;
        box-shadow: 0px 0px 34px 1px rgba(222,222,222,1) !important;
        
        .icon-wrapper{
            color:#dadada;
            i{
                font-size:2rem;
            }
        }
        .text-item{
            font-size:0.8rem;
            font-weight: 600;
        }
    }
    .item-container {
        display: flex;
        align-items: center;
        margin: 24px 0;
        padding: 14px 16px;
        border-radius: 10px;
        background: #a0cbff91;
        // border: 1px solid #a0cbff91;
        .icon-wrapper {
            padding: 10px;
            // background: #19477e26;
            background: #19477ede;
            border-radius: 9px;
            i {
            color: #fff;
            }
        }
        .text-wrapper {
            padding: 0 12px;
            .text-heading {
                padding: 0 12px;
                font-weight: 600;
                font-size: 1.2rem;
                color: #000;
            }
            .text-sub-heading {
                font-size: 0.8rem;
            }
        }
        // .page-dashboard{
        //     .section-header{
        //         background: #4caf50;
        //         padding: 6px;
        //         height: 48px;
        //         color: #fff;
        //     }
        //     .item-wrapper{
        //         padding: 10px;
        //         text-align: center;
        //         min-height: 100px;
        //         display: flex;
        //         align-items: center;
        //         flex-direction: column;
        //         justify-content: space-between;
        //         border-radius: 0;
        //         i{
        //             font-size: 3.1rem;
        //             color: #01a6bc;
        //         }
        //         p{
        //             margin: 0;
        //             padding: 0;
        //             text-align: center;
        //             font-weight: 500;
        //             color: #5a5a5a;
        //             text-transform: capitalize;
        //             font-size: 0.8rem;
        //             letter-spacing: 0.7px;
        //         }
        //     }
        // }
    }
    // .footer-copyright{
    //     position: fixed;
    //     bottom: 0;
    //     text-align: center;
    //     background: #ff5252;
    //     width: 100%;
    //     color: #fff;
    //     font-weight: 400;
    //     padding: 10px;
    //     p{
    //         margin:0;
    //     }
    // }
</style>